<!--
 * @Author: 月魂
 * @Date: 2021-06-01 09:34:14
 * @LastEditTime: 2021-07-04 17:06:05
 * @LastEditors: 月魂
 * @Description:
 * @FilePath: \nepal\src\views\Home.vue
-->
<template>
  <div class="home">
    <div class="header">
      <span class="header-text">{{ this.$t('title') }}</span>
      <NavMenu class="nav" />
      <div class="header-right">
        <!-- <van-button class="btn" size="small" type="default" v-if="selected === 'en'" @click="changeLang('zh-CN')">En</van-button>
        <van-button class="btn" size="small" type="default" v-else @click="changeLang('en')">中文</van-button> -->
        <Menu class="menu" />
      </div>
    </div>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <img alt="history" src="../assets/history.jpg" class="banner" @click="jump('/history')">
      </van-swipe-item>
      <van-swipe-item>
        <img alt="warriors" src="../assets/warriors.jpg" class="banner" @click="jump('warriors')">
      </van-swipe-item>
    </van-swipe>

    <div class="part-des">
      <h4 class="part-des-title">{{ this.$t('sTitle') }}</h4>
      <div v-for="item in this.$t('des')" :key="item" class="des" :class="selected === 'en' ? 'en-title' : ''">{{ item }}</div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Vue from 'vue'
import Menu from '../components/menu.vue'
import NavMenu from '../components/nav.vue'
import Footer from '../components/footer.vue'
import { Button, Tab, Tabs, Popover, Icon, Swipe, SwipeItem } from 'vant'
Vue.use(Button).use(Tabs).use(Tab).use(Popover).use(Icon).use(Swipe).use(SwipeItem)

export default {
  name: 'Home',
  components: {
    Menu,
    NavMenu,
    Footer
  },
  data() {
    return {
      selected: 'en',
      active: 0
    }
  },
  mounted() {
    localStorage.clear()
    const lang = localStorage.getItem('locale')
    this.selected = lang || 'en'
  },
  methods: {
    changeLang(val) {
      this.selected = val
      this.$i18n.locale = val
      localStorage.setItem('locale', val)
    },
    jump(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  min-height: 100%;
  background-color: #b24500;
  overflow: hidden;
  color: #fff;
  .header {
    height: 40px;
    display: flex;
    padding: 0 10px;
    overflow: hidden;
    justify-content: space-between;
    .menu {
      display: block;
    }
    .nav {
      display: none;
    }
    @media (min-width: 800px) {
      .nav {
        display: block;
      }
      .menu {
        display: none;
      }
    }
    .header-text {
      display: inline-block;
      line-height: 40px;
    }
    .header-right {
      display: flex;
      .btn {
        margin-top: 4px;
        margin-right: 10px;
      }
    }
  }
  .banner {
    width: 100%;
  }
  .part-des {
    margin-top: 10px;
    .part-des-title {
      text-align: center;
      margin: 0;
    }
    @media (min-width: 1200px) {
      & {
        width: 1200px;
        margin: auto;
      }
    }
    .des {
      padding: 5px 10px;
      text-indent: 2em;
      font-size: 14px;
      line-height: 1.5;
      color: #fff;
      text-align: justify;
    }
    @media (min-width: 800px) {
      .des {
        font-size: 16px;
      }
    }
  }
}
</style>
